import script from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"

import "./SupportWidget.vue?vue&type=style&index=0&id=aeba06ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeba06ae"]])

export default __exports__